import breadcrumbs from './modules/breadcrumbs'
import website from './modules/website'

export default {
  breadcrumbs,
  website,
}
